import utils from "@bigcommerce/stencil-utils";

export default function (tScroll) {
  function initScrollEvent(tScroll) {
    homeParallax(tScroll);
  }
  function homeParallax(tScroll) {
    const $homeParallax = $(".haloBannerParallax");

    if ($homeParallax.length) {
      $homeParallax.each(function (i) {
        const $homeParallaxHaft = $homeParallax.eq(i).outerHeight() / 2;
        const $homeParallaxTop =
          $homeParallax.eq(i).offset().top - screen.height;
        const $homeParallaxBottom =
          $homeParallax.eq(i).offset().top + $homeParallax.outerHeight();
        var img = $homeParallax.eq(i).find("img");

        if (tScroll < $homeParallaxBottom && tScroll > $homeParallaxTop) {
          $homeParallax
            .eq(i)
            .find(".haloBannerParallax__img")
            .addClass("is-zoom");
        } else {
          $homeParallax
            .eq(i)
            .find(".haloBannerParallax__img")
            .removeClass("is-zoom");
        }

        if (
          tScroll > $homeParallaxBottom - $homeParallaxHaft &&
          tScroll < $homeParallaxBottom
        ) {
          img.css({
            top: "-20%",
            transform: "translate(0, 20%) scale3d(1.1, 1.1, 1.1)",
            transition: "all .8s ease",
          });
        } else if (
          tScroll <
          $homeParallaxBottom - $homeParallaxHaft - screen.height
        ) {
          img.css({
            top: "20%",
            transform: "translate(0, -20%) scale3d(1.1, 1.1, 1.1)",
            transition: "all .8s ease",
          });
        } else {
          img.css({
            top: "",
            transform: "",
            transition: "",
          });
        }
      });
    }
  }
  initScrollEvent(tScroll);
}
